import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRaspberrypiComponent } from './simple-icons-raspberrypi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRaspberrypiComponent ],
    exports:      [ SimpleIconsRaspberrypiComponent ],
    bootstrap:    []
})
export class SimpleIconsRaspberrypiModule {}
